import React from 'react'
import styled from 'styled-components'

import { Label } from '../../../../../1stlog-ui/src/components/Field'
import { TOrderEntryReusableBoxInfo } from '../../AdditionalServices/types'

const Wrapper = styled.div`
  display: flex;
  align-items: start;
`

const Image = styled.img`
  max-height: 120px;
`

const Content = styled.div``

export type TProps = {
  data: TOrderEntryReusableBoxInfo
}

const ReusableBoxInfo = (props: TProps): React.ReactElement => {
  const { data } = props

  if (!data) {
    return <></>
  }

  const { image, name, height, length, width, maxWeight } = data

  return (
    <Wrapper>
      <Content>
        {name && (
          <div>
            <Label>{i18n.t('name', 'Name')}</Label>
            <div>{name}</div>
          </div>
        )}
        {length && width && height && (
          <div>
            <Label>{`${i18n.t('measurements', 'Abmessungen')} (${i18n.t(
              'length_short',
              'L',
            )} x
${i18n.t('width_short', 'B')} x ${i18n.t('height_short', 'H')}
${i18n.t('in_cm', 'in cm')})`}</Label>
            <div>
              {length} x {width} x {height}
            </div>
          </div>
        )}
        {maxWeight && (
          <div>
            <Label>
              {i18n.t('max_allowed_weight', 'Maximal erlaubtes Gewicht')}
            </Label>
            <div>{maxWeight} kg</div>
          </div>
        )}
      </Content>
      {image && <Image src={image} alt="" className="ml-2" />}
    </Wrapper>
  )
}

export default ReusableBoxInfo
